import { RegisterClass } from "../../../../Misc/typeStore";
import { NodeParticleBlockConnectionPointTypes } from "../../Enums/nodeParticleBlockConnectionPointTypes";
import { NodeParticleBlock } from "../../nodeParticleBlock";
import { type NodeParticleConnectionPoint } from "../../nodeParticleBlockConnectionPoint";
import { type NodeParticleBuildState } from "../../nodeParticleBuildState";
import { type ThinParticleSystem } from "core/Particles/thinParticleSystem";
import { type Particle } from "core/Particles/particle";
import { _ConnectAtTheEnd } from "core/Particles/Queue/executionQueue";

/**
 * Block used to provide the basic update functionality for particle sprite index.
 */
export class BasicSpriteUpdateBlock extends NodeParticleBlock {
    /**
     * Create a new BasicSpriteUpdateBlock
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this.registerInput("particle", NodeParticleBlockConnectionPointTypes.Particle);
        this.registerOutput("output", NodeParticleBlockConnectionPointTypes.Particle);
    }

    /**
     * Gets the particle component
     */
    public get particle(): NodeParticleConnectionPoint {
        return this._inputs[0];
    }

    /**
     * Gets the output component
     */
    public get output(): NodeParticleConnectionPoint {
        return this._outputs[0];
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "BasicSpriteUpdateBlock";
    }

    /**
     * Builds the block
     * @param state defines the current build state
     */
    public override _build(state: NodeParticleBuildState) {
        const system = this.particle.getConnectedValue(state) as ThinParticleSystem;

        const processSprite = (particle: Particle) => {
            state.particleContext = particle;
            state.systemContext = system;
            particle.updateCellIndex();
        };

        const spriteProcessing = {
            process: processSprite,
            previousItem: null,
            nextItem: null,
        };

        if (system._updateQueueStart) {
            _ConnectAtTheEnd(spriteProcessing, system._updateQueueStart);
        } else {
            system._updateQueueStart = spriteProcessing;
        }

        this.output._storedValue = system;
    }
}

RegisterClass("BABYLON.BasicSpriteUpdateBlock", BasicSpriteUpdateBlock);
